export class Paths {
  public static readonly CONTENT_MANAGEMENT = '/admincanal/admon-channels/content-management';
  public static readonly CHANNEL_STATUS = '/mac/v1/channels/';
  public static readonly SECURITY = '/securityv2/v2/security';
  public static readonly SECURITY_OIDC: '/securityv2/OIDC/v2.0';
  public static readonly TOKEN_GUEST = '/securityv2/v2/security/token';
}
